/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_3_QInputs */

const en_b2b_faq_3_q = /** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I export my customer data?`)
};

const es_b2b_faq_3_q = /** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo exportar los datos de mis clientes?`)
};

const fr_b2b_faq_3_q = /** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je exporter mes données clients ?`)
};

const de_b2b_faq_3_q = /** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich meine Kundendaten exportieren?`)
};

const id_b2b_faq_3_q = /** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah saya mengekspor data pelanggan saya?`)
};

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const ja_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const zh_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const ar_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const it_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const ru_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const pt_b2b_faq_3_q = en_b2b_faq_3_q;

/** @type {(inputs: B2b_Faq_3_QInputs) => LocalizedString} */
const ko_b2b_faq_3_q = en_b2b_faq_3_q;

/**
* | output |
* | --- |
* | "Can I export my customer data?" |
*
* @param {B2b_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_3_q = /** @type {((inputs?: B2b_Faq_3_QInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_3_QInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_3_q(inputs)
	if (locale === "es") return es_b2b_faq_3_q(inputs)
	if (locale === "fr") return fr_b2b_faq_3_q(inputs)
	if (locale === "de") return de_b2b_faq_3_q(inputs)
	if (locale === "ja") return ja_b2b_faq_3_q(inputs)
	if (locale === "zh") return zh_b2b_faq_3_q(inputs)
	if (locale === "ar") return ar_b2b_faq_3_q(inputs)
	if (locale === "id") return id_b2b_faq_3_q(inputs)
	if (locale === "it") return it_b2b_faq_3_q(inputs)
	if (locale === "ru") return ru_b2b_faq_3_q(inputs)
	if (locale === "pt") return pt_b2b_faq_3_q(inputs)
	return ko_b2b_faq_3_q(inputs)
});